import cloneDeep from "lodash/cloneDeep";
import compact from "lodash/compact";
import {
  reorder,
  LIST_DESTINATIONS,
  deconstructSourceAndDestination
} from "utils/drag";

export const reorderFeatureGroupLayout = ({
  layout,
  layoutPath,
  remainingFeatureGroups,
  setFieldValue,
  setFieldTouched
}) => ({ source, destination }) => {
  const droppedOffList = !destination;
  if (droppedOffList) {
    return;
  }
  const {
    destinationDropId,
    destinationIndex,
    sourceDropId,
    sourceIndex
  } = deconstructSourceAndDestination({ source, destination });

  const updatedLayout = cloneDeep(layout);

  /**
   * Drop has happened between two lists so an object is being moved
   */
  const changedList = sourceDropId !== destinationDropId;
  if (changedList) {
    const FROM_FEATURE_GROUP_TABLE =
      destinationDropId === LIST_DESTINATIONS.FEATURE_GROUP_STORE;
    const TO_FEATURE_GROUP_TABLE =
      destinationDropId === LIST_DESTINATIONS.FEATURE_GROUP_TABLE;

    if (FROM_FEATURE_GROUP_TABLE) {
      updatedLayout.splice(sourceIndex, 1);
      setFieldValue(layoutPath, compact(updatedLayout));
      setFieldTouched(layoutPath, true);
    } else if (TO_FEATURE_GROUP_TABLE) {
      const featureGroupInMotion = remainingFeatureGroups[sourceIndex];
      const newProdLayout = {
        uuid: featureGroupInMotion.uuid
      };
      updatedLayout.splice(destinationIndex, 0, newProdLayout);
      setFieldValue(layoutPath, compact(updatedLayout));
      setFieldTouched(layoutPath, true);
    } else if (!TO_FEATURE_GROUP_TABLE && !FROM_FEATURE_GROUP_TABLE) {
      throw new Error(`Invalid destination: ${destinationDropId}`);
    }
  } else {
    const reorderedLayout = reorder(
      updatedLayout,
      source.index,
      destination.index
    );
    setFieldValue(layoutPath, compact(reorderedLayout));
    setFieldTouched(layoutPath, true);
  }
};
